import { CommonActions } from "@react-navigation/native";

import { slugOf } from "@/components/navigation/routeGroups";
import { rememberRoomCopy } from "./roomCopies";

// Phones: a screen opened from an event's screen (How to Go Live, Add a room)
// moves that event screen to `room` as well, so Back lands on the room the
// person picked or just added, as on wide layouts. `fromSlug` is the room the
// event screen shows now. Returns whether there was such a screen to move.
export const moveEventScreenBelow = (navigation, routeKey, fromSlug, room) => {
  rememberRoomCopy(room);
  const { routes } = navigation.getState();
  const below = routes[routes.findIndex((r) => r.key === routeKey) - 1];
  if (below?.name !== "EventEdit" || slugOf(below) !== fromSlug) return false;
  navigation.dispatch({
    ...CommonActions.setParams({ slug: room.slug, event: undefined }),
    source: below.key,
  });
  return true;
};
